<template>
  <div>
    <PageHeader :page="page" :has-add="false" has-return @onReturn="goBack" />
    <div v-if="statusHistory">
      <div class="summary-container px-5 py-3">
        <div class="d-flex">
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-address-book text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Estudiante:</span>
              <span class="data-content">
                {{ statusHistory.studentFullName }}
              </span>
            </div>
          </div>
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-calendar-edit text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Fecha de Referido:</span>
              <span class="data-content">
                {{ statusHistory.referralDate | date }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start  col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-ballot-check text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Modalidad:</span>
              <span class="data-content">
                {{ statusHistory.serviceModalityTypeName }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-clock text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Frecuencia:</span>
              <span class="data-content">
                {{ statusHistory.frequencyTypeName }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex mt-2">
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-address-book text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Número de Referido:</span>
              <span class="data-content">{{ referralNumber }}</span>
            </div>
          </div>
          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-calendar-edit text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Fecha Desde:</span>
              <span class="data-content">
                {{ statusHistory.effectiveDateFrom | date }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start  col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-calendar-edit text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Fecha Hasta:</span>
              <span class="data-content">
                {{ statusHistory.effectiveDateTo | date }}
              </span>
            </div>
          </div>

          <div class="d-flex align-items-start col-3 p-0">
            <div class="icon-container">
              <i class="fas fa-clock text-orange" />
            </div>
            <div class="d-flex flex-column">
              <span class="data-title">Duración:</span>
              <span class="data-content">
                {{ statusHistory.durationTypeName }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <div
          v-for="(card, cardIndex) in statusHistory.vwThrpyLastAdmissionHistory"
          :key="cardIndex"
        >
          <RowCardItemCard
            v-if="
              cardIndex >= (pagination.currentPage - 1) * pageSize &&
                cardIndex < pagination.currentPage * pageSize
            "
            center-status
            :status="card.admissionStatusName"
            :status-class="getStatusClass(card.admissionStatusId)"
          >
            <!-- Cuerpo de la Card -->
            <div slot="body">
              <div class="col-12 p-0 d-flex">
                <div class="col-2 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Ocurrido:</span>
                    <span class="data-content">
                      {{ card.dateOfAction | date }}
                    </span>
                  </div>
                </div>
                <div class="col-3 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Compañía:</span>
                    <span class="data-content">{{ card.companyName }}</span>
                  </div>
                </div>
                <div class="col-2 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Centro:</span>
                    <span class="data-content">{{ card.centeR_NAME }}</span>
                  </div>
                </div>
                <div class="col-2 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Visitas:</span>
                    <span class="data-content ml-1 cursor-pointer">
                      {{ card.visitCount }}
                    </span>
                  </div>
                </div>
                <div class="col-3 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Cambiado por:</span>
                    <span class="data-content">{{ card.actionUserName }}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 p-0 d-flex mt-3">
                <div v-if="card.admissionDate" class="col-2 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Fecha de admisión:</span>
                    <span class="data-content">
                      {{ card.admissionDate | date }}
                    </span>
                  </div>
                </div>
                <div v-if="card.specialist" class="col-3 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Especialista:</span>
                    <span class="data-content">{{ card.specialist }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="card.rejectedReasonDescription"
                class="col-12 p-0 d-flex mt-2"
              >
                <div class="col-12 p-0">
                  <div class="d-flex flex-column">
                    <span class="data-title">Descripción del rechazo:</span>
                    <span class="data-content">
                      {{ card.rejectedReasonDescription }}
                    </span>
                  </div>
                  <div class="col-12 p-0 mt-2">
                    <Error
                      v-if="shouldShowRejectionAlert(card)"
                      is-alert-mode
                      message="Se deberá enmendar el PEI para eliminar los servicios rechazados por el encargado del estudiante."
                    />
                  </div>
                </div>
              </div>
            </div>
          </RowCardItemCard>
        </div>
      </div>
    </div>
    <Pagination
      id="pgStatusHistory"
      :show-text="false"
      :data="pagination"
      @pagination-go-page="goToPage"
    />
  </div>
</template>

<script>
import PageHeader from '@/components/common/page/PageHeader';
import thrpiesAdmissionStatuses from '@/utils/constants/thrpiesAdmissionStatuses.js';
import referralRejectionReason from '@/utils/constants/pei/referral/referralRejectionReason.js';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import Pagination from '@/components/common/Pagination.vue';
import Error from '@/components/common/Error';
export default {
  name: 'StatusHistory',
  data() {
    return {
      referralNumber: null,
      page: {
        icon: 'fas fa-user-edit',
        title: 'Ver Historial',
        routes: ['Inicio', 'PEI', 'Historial de Servicios'],
      },
      pageSize: 6,
      pagination: {
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 0,
      },
      statusHistory: null,
    };
  },
  components: {
    PageHeader,
    RowCardItemCard,
    Pagination,
    Error,
  },
  async mounted() {
    await this.loadStatusHistory();
  },
  methods: {
    async loadStatusHistory() {
      let self = this;
      let admissionId = self.$root.$route.params.admissionId;
      self.referralNumber = self.$root.$route.params.referralNumber;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(`/api/thrpyadmission/GetLastReferralHistory/${admissionId}`)
          .then((res) => {
            self.statusHistory = res.data;
            self.pagination.totalItemCount =
              self.statusHistory.vwThrpyLastAdmissionHistory.length;
            self.pagination.pageCount = Math.ceil(
              self.pagination.totalItemCount / self.pageSize
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    goToPage(page) {
      this.pagination.currentPage = page;
    },
    goBack() {
      this.$router.go(-1);
    },
    shouldShowRejectionAlert(card) {
      return (
        card?.rejectedReasonId ===
        referralRejectionReason.LosEncargadosRechazaronOfrecimientoServicioTerapeutico
      );
    },
    getStatusClass(status) {
      switch (status) {
        case thrpiesAdmissionStatuses.ReferidoAlDirectorCSEE:
        case thrpiesAdmissionStatuses.ReferidoRechazado: {
          return 'brown';
        }
        case thrpiesAdmissionStatuses.ServicioRelacionadoActivo: {
          return 'green';
        }
        case thrpiesAdmissionStatuses.Asignado:
        case thrpiesAdmissionStatuses.Admitido:
        case thrpiesAdmissionStatuses.Vinculado: {
          return 'yellow';
        }
        case thrpiesAdmissionStatuses.NoVinculado:
        case thrpiesAdmissionStatuses.Alertas: {
          return 'pink';
        }
        case thrpiesAdmissionStatuses.AprobadoEnRemedioProvisional: {
          return 'violet';
        }
        default: {
          return 'orange';
        }
      }
    },
  },
};
</script>

<style scoped>
.icon-container {
  margin-top: 3px;
  margin-right: 12px;
}
.icon-container .far,
.icon-container .fas {
  font-size: 20px;
}
.summary-container {
  border-radius: 5px;
  padding: 12px;
  border: 12px solid #f4f6f3;
}
</style>
